import { useAuthStore } from "@/store";
import { useCallback, useMemo } from "react";

/**
 * Central permission helper.
 *
 * Roles that carry `interview.schedule` / `interview.update`:
 *   Admin · HR Manager · Hiring Manager · HR Executive · Technical Recruiter
 * Roles that do NOT (Mentor, Internship Coordinator) must never see the
 * schedule / edit controls — hide them instead of letting the API 403.
 */
export const usePermissions = () => {
  const user = useAuthStore((state) => state.user);

  const permissions = useMemo(() => user?.permissions ?? [], [user]);

  /** True when every listed permission is present. */
  const can = useCallback(
    (...required: string[]) => required.every((p) => permissions.includes(p)),
    [permissions]
  );

  /** True when at least one listed permission is present. */
  const canAny = useCallback(
    (...required: string[]) => required.some((p) => permissions.includes(p)),
    [permissions]
  );

  return { permissions, can, canAny };
};

export default usePermissions;
